<template>
  <v-tooltip bottom :disabled="!header.icon">
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <template v-if="!header.icon">
          {{ header.text }}
        </template>
        <template v-else>
          <v-icon size="24" style="opacity: unset" color="primary">{{ header.icon }}</v-icon>
        </template>
      </span>
    </template>
    <span>
      {{ header.text }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: "IconDataTableHeader",
  props: {
    header: {
      required: true,
      type: Object
    }
  }
};
</script>

<style scoped></style>
